import { TaskStatus } from '../../../types/video';
import noop from '../../../utils/noop';

import { UploadOptions, UploadTask } from './types';

async function upload(
  file: File,
  { onProgress = noop, signal, serviceUrl, apiKey }: UploadOptions,
): Promise<UploadTask> {
  // It's not possible to track progress with fetch in case of uploading files
  const xhr = new XMLHttpRequest();

  const formData = new FormData();
  formData.append('file', file);
  formData.append('type', 'wve-input');

  xhr.upload.addEventListener('progress', (event) => {
    if (event.lengthComputable) {
      const { loaded: processed, total } = event;
      onProgress({
        processed,
        total,
        percent: (processed / total) * 100,
      });
    }
  });

  const data = new Promise<UploadTask>((resolve) => {
    const onError = () => {
      const error = xhr.responseText ? xhr.responseText : 'connectionError';
      resolve({ status: TaskStatus.Error, error });
    };

    const onAbort = () => {
      resolve({ status: TaskStatus.Aborted });
    };

    const onLoad = () => {
      try {
        const url: string = JSON.parse(xhr.responseText).result.url;

        if (url) {
          resolve({ status: TaskStatus.Done, url });
        } else {
          onError();
        }
      } catch (_e) {
        onError();
      }
    };

    xhr.addEventListener('load', onLoad);
    xhr.addEventListener('error', onError);
    xhr.addEventListener('abort', onAbort);
  });

  xhr.open('POST', serviceUrl, true);
  xhr.setRequestHeader('x-api-key', apiKey);
  xhr.send(formData);
  signal?.addEventListener('abort', () => xhr.abort());

  return data;
}

export default upload;
